import { createContext, useContext } from 'react';

type Props = {
  children: React.ReactNode;
  value: boolean;
};

const IsInModalContext = createContext<boolean>(false);

export function IsInModalProvider({ value, children }: Props) {
  return (
    <IsInModalContext.Provider value={value}>
      {children}
    </IsInModalContext.Provider>
  );
}

export function useIsInModal() {
  return useContext(IsInModalContext);
}
